<template>
  <div class="s-reviews-skeleton">
    <div v-for="index in amount" :key="index">
      <SReviewSkeleton />
      <PDivider v-if="index < amount" class="s-reviews-skeleton__divider" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PDivider from "@/atoms/PDivider.vue";
import SReviewSkeleton from "@/other/review/SReviewSkeleton.vue";

withDefaults(defineProps<{ amount?: number }>(), {
  amount: 10,
});
</script>

<style lang="postcss">
.s-reviews-skeleton {
  @apply flex flex-col;

  &__divider {
    @apply my-7;
  }
}
</style>
